import { render } from "./EmbedCode.vue?vue&type=template&id=8e01bf86&scoped=true"
import script from "./EmbedCode.vue?vue&type=script&lang=js"
export * from "./EmbedCode.vue?vue&type=script&lang=js"

import "./EmbedCode.vue?vue&type=style&index=0&id=8e01bf86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e01bf86"]])

export default __exports__